import React from 'react';
import ComponentWrapper from '../../../components/layout/ComponentWrapper';
import { StudyDesignOverview, StudyCopyBlock } from '../index';
import styled from 'styled-components';

const CustomStyles = styled.div`
    h6{
    font-family: 'proxima-nova', Helvetica, sans-serif;
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    color: #444444;
    margin: 1em auto;
    }
`;

const ESO3 = () => (
    
    <ComponentWrapper>
        <CustomStyles>
        <StudyDesignOverview
            title="Study Overview" 
            description="
            <p>The efficacy of KEYTRUDA was investigated in KEYNOTE-180, a multicenter, nonrandomized, open-label trial that enrolled 121 patients with locally advanced or metastatic esophageal cancer who progressed on or after at least 2 prior systemic treatments for advanced disease. With the exception of the number of prior lines of treatment, the eligibility criteria were similar to and the dosage regimen identical to KEYNOTE-181.</p>
            <p>The major efficacy outcome measures were ORR and DoR according to RECIST v1.1, modified to follow a maximum of 10 target lesions and a maximum of 5 target lesions per organ, as assessed by BICR.</p>
            <p>Among the 121 patients enrolled, 29% (n=35) had ESCC that expressed PD-L1 CPS ≥10. The baseline characteristics of these 35 patients were: median age of 65 years (range: 47 to 81), 51% age 65 or older; 71% male; 26% White and 69% Asian; 40% had an ECOG PS of 0 and 60% had an ECOG PS of 1. One hundred percent had M1 disease.</p>"        
        />
        </CustomStyles>
        {/* <StudyCopyBlock 
            
            description={` 
                <p>Among the 749 patients, randomized, 647 (86%) had tumors that expressed PD-L1 with a CPS ≥1. PD-L1 status was determined using the PD-L1 IHC 22C3 pharmDx kit. The population characteristics of these 647 patients were: median age of 63 years (range: 27 to 89), 41% age 65 or older; 83% male; 36% White, 54% Asian, and 1% Black; 41% ECOG PS of 0 and 59% ECOG PS of 1. Ninety-one percent had M1 disease and 9% had M0 disease. Seventy-four percent had a tumor histology of squamous cell carcinoma, and 26% had adenocarcinoma. </p>
            `} 
            definitions="BICR = blinded independent central review; ECOG PS = Eastern Cooperative Oncology Group performance status; RECIST v1.1 = Response Evaluation Criteria In Solid Tumors v1.1."
        /> */}
    </ComponentWrapper>
);

export default ESO3
